import { createDuck } from '@/utils'
import { getProductList } from '@/services/api/home'
// @ts-ignore
import { getRemindData } from '@/services/api/common'
import { isObject } from '@/utils/utils'
// import { isSelectAll, getAllSelectedSubItemId, formatCartList } from '@/utils/cartUtils'
// import { Toast } from 'antd-mobile'
export const duck = createDuck({
  name: 'homeDuck',
  initialState: {
    list: [],
    remindData: null,
  },
  actions: {
    fetchHomeData() {
      // @ts-ignore
      return async dispatch => {
        dispatch(duck.fetchProductList())
        dispatch(duck.fetchRemindData())
      }
    },
    fetchProductList() {
      // @ts-ignore
      return async dispatch => {
        const { data, error } = await getProductList()
        if (!error) {
          // @ts-ignore
          const _res = data.map(item => {
            return {
              ...item,
              images: item.shopUrl.split(','),
            }
          })
          dispatch(
            duck.change({
              list: _res,
            }),
          )
        }
      }
    },

    fetchRemindData() {
      // @ts-ignore
      return async dispatch => {
        const { data } = await getRemindData(-1)
        if (isObject(data)) {
          dispatch(
            duck.change({
              remindData: data,
            }),
          )
        }
      }
      //getRemindData
    },

    // fetchAward() {

    // }
  },
})
